import React, { useState } from 'react';
import { Table, TableBody, TableHead, Paper, Grid, TextField, Button, TableRow, IconButton, TableCell, Tooltip } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { CkEditorText } from '../../../shared_elements';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import { useSnackbar } from 'notistack';
import { checkApiStatus, onCheckFormPermission } from '../../../utils_v2';
import { globalDeleteService } from '../../../globalServices';
import { trackActivity } from '../../../utils/mixpanel';
import { DeletePopUp } from '../../../shared_elements';
import { regexConstants } from '../../../constants/regEx';

function FleetComposition({ data, setData, onFieldChange, callthisapi, getResponseBack, currentFormDetail, setInitialValue, setLoading, isLoading, formSave, setFormSave }) {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [deleteModal, setDeleteModal] = useState({ modal: false, data: null })

    const fleetCompDis = data?.powerplant_fleet_tech_summaries ?
        data?.powerplant_fleet_tech_summaries?.power_fleet_composition?.filter(item => item?.id)?.length === data?.powerplant_fleet_tech_summaries?.power_fleet_composition?.length : [];

    const fleetCompfn = (modeTye, row,extra) => {
        if (modeTye === 'add') {
            setData(prev => (
                {
                    ...prev,
                    powerplant_fleet_tech_summaries: {
                        ...prev.powerplant_fleet_tech_summaries,
                        power_fleet_composition: [
                            ...prev.powerplant_fleet_tech_summaries?.power_fleet_composition,
                            { aircraft_type: null, quantity: null, spare_engines: null,deltedId:Math.floor(Math.random() * 90) + 10  }]
                    }
                }

            ));
        } else if (row?.id) {
            setLoading(true)
            globalDeleteService(`/technical/t015/basic-inspection/${row?.id}/delete/?module=fleet`)
                .then(response => {
                    if (checkApiStatus(response)) {
                        getResponseBack()
                        setLoading(false)
                        setDeleteModal({ modal: false, data: null })
                        enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                        trackActivity('Project Management', {
                            event_type: 'Fleet Composition Delete',
                            page_title: 'T015 Form',
                            deleted_id: row?.id || '',
                            success_msg: response?.data?.message
                        });
                    } else {
                        getResponseBack()
                        setLoading(false)
                        setDeleteModal({ modal: false, data: null })
                        enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                        trackActivity('Project Management', {
                            event_type: 'Fleet Composition Delete',
                            page_title: 'T015 Form',
                            deleted_id: row?.id || '',
                            success_msg: response?.data?.message
                        });
                    }
                });
        } else {
            setData(prev => (
                {
                    ...(prev),
                    powerplant_fleet_tech_summaries: {
                        ...prev.powerplant_fleet_tech_summaries,
                        power_fleet_composition:
                            [...data?.powerplant_fleet_tech_summaries.power_fleet_composition]?.filter(item => item?.deltedId !== extra?.deltedId)
                    }
                }

            ));
        }

    }


    return (
        <section className='form-t015'>
            <Paper square style={{ padding: '10px', marginBottom: "5px" }} elevation={8}>
                <ul className='list-inline'>
                    <li className='list-inline-item'><h4 style={{ margin: '10px 0px 10px' }}>7. Fleet Composition :</h4></li>
                    <li className='list-inline-item' style={{ float: 'right' }}>
                        {!(formSave?.type === 'fleet' && formSave?.open) && (
                            <Tooltip title="Edit" placement="top">
                                <IconButton disabled={!onCheckFormPermission(currentFormDetail) || formSave?.isdisabled} style={{ cursor: 'pointer' }} color="primary" size="small" onClick={() => setFormSave({ open: true, type: 'fleet',isdisabled:true })} > <EditIcon /> </IconButton>
                            </Tooltip>
                        )}
                        {formSave?.type === 'fleet' && (
                            <>
                                <Tooltip title="Cancel" placement="top">
                                    <Button style={{ marginInline: '5px' }} variant="outlined" color="primary" onClick={() => { getResponseBack(); setFormSave({ open: false, type: '',isdisabled:false }); }} size="small" > Cancel </Button>
                                </Tooltip>
                                <Tooltip title="Save" placement="top">
                                    <Button variant="contained" color="primary" onClick={() => { callthisapi('', data); setFormSave({ open: false, type: '',isdisabled:false }); }} size="small" > Save </Button>
                                </Tooltip>
                            </>
                        )}
                    </li>
                </ul>
                <Grid container spacing={1}>
                    <Grid item xs={11}>
                        <span>The composition of </span>
                        <TextField
                            variant='outlined'
                            disabled
                            value={data?.lessee_id || ''}
                            InputLabelProps={{ shrink: true }}
                            placeholder="Enter"
                            size='small'
                        />
                        <span className='span-style'>fleet</span>
                        <Autocomplete
                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'fleet'}
                            options={['was', 'was not']}
                            getOptionLabel={option => option}
                            style={{ display: 'inline-grid', marginLeft: '5px', width: '125px' }}
                            value={['was', 'was not'].filter(item => item === data?.powerplant_fleet_tech_summaries?.fleet_composition?.discussed)[0] || null}
                            id="discussed"
                            onChange={(e, value) => onFieldChange(e, 'discussed', value, 'powerplant_fleet_tech_summaries', '', '', 'fleet_composition')}
                            renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin="normal" fullWidth />}
                        />
                        <span className='span-style'>discussed.</span>
                    </Grid>
                    <Grid item xs={1} style={{ textAlign: 'end' }}>
                        <Button disabled={ formSave?.type !== 'fleet' || !onCheckFormPermission(currentFormDetail)} onClick={() => fleetCompfn("add")} color="primary" variant="contained" size="small" style={{ margin: '5px' }} >+ ADD</Button>
                    </Grid>
                </Grid>

                <Table className='mui-table-format-t015' >
                    <TableBody >
                        {data?.powerplant_fleet_tech_summaries?.power_fleet_composition?.map((item, index) => (
                            <TableRow>
                                <TableCell><h6>Aircraft Type</h6></TableCell>
                                <TableCell >
                                    <TextField
                                        disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'fleet'}
                                        variant='outlined'
                                        id='aircraft_type'
                                        onChange={(e) => onFieldChange(e, 'aircraft_type', e.target.value, 'powerplant_fleet_tech_summaries', index, '', 'power_fleet_composition')}
                                        placeholder="Enter.."
                                        fullWidth
                                        value={item?.aircraft_type || ''}
                                        inputProps={{ maxLength: 50 }}
                                    />
                                </TableCell>
                                <TableCell><h6>Quantity</h6></TableCell>
                                <TableCell>
                                    <TextField
                                        disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'fleet'}
                                        variant='outlined'
                                        id='quantity'
                                        placeholder="Enter.."
                                        fullWidth
                                        onChange={(e) => { regexConstants.onlyNumeric.test(e.target.value) ? onFieldChange(e, 'quantity', e.target.value, 'powerplant_fleet_tech_summaries', index, '', 'power_fleet_composition') : e.preventDefault() }}
                                        value={item?.quantity || ''}
                                        inputProps={{ maxLength: 5 }}
                                    />
                                </TableCell>
                                <TableCell><h6>Spare Engines</h6></TableCell>
                                <TableCell>
                                    <TextField
                                        disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'fleet'}
                                        variant='outlined'
                                        id='spare_engines'
                                        onChange={(e) => onFieldChange(e, 'spare_engines', e.target.value, 'powerplant_fleet_tech_summaries', index, '', 'power_fleet_composition')}
                                        placeholder="Enter.."
                                        fullWidth
                                        value={item?.spare_engines || ''}
                                        inputProps={{ maxLength: 50 }}
                                    />
                                </TableCell>
                                <TableCell align='center'>
                                       <Tooltip title='Delete' arrow>
                                    <IconButton disabled={formSave?.type !== 'fleet' || !onCheckFormPermission(currentFormDetail)} color='secondary' >
                                        <DeleteOutlinedIcon  onClick={() => { item?.id ? setDeleteModal({ modal: true, data: item }) : fleetCompfn('','',item) }} />
                                    </IconButton>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                        ))
                        }

                    </TableBody>
                </Table>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <TextField
                            variant='outlined'
                            disabled
                            value={data?.lessee_id || ''}
                            InputLabelProps={{ shrink: true }}
                            placeholder="Enter"
                            size='small'
                            inputProps={{ maxLength: 50 }}
                        />
                        <Autocomplete
                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'fleet'}
                            options={['will', 'will not']}
                            getOptionLabel={option => option}
                            className='engine-stand-select'
                            style={{ display: 'inline-grid', marginLeft: '5px', width: '125px' }}
                            id="require"
                            value={['will', 'will not'].filter(item => item === data?.powerplant_fleet_tech_summaries?.fleet_composition?.require)[0] || null}
                            onChange={(e, value) => onFieldChange(e, 'require', value, 'powerplant_fleet_tech_summaries', '', '', 'fleet_composition')}
                            renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin="normal" fullWidth />}
                        />
                        <span className='span-style'>require further spare engine support at this time.</span>
                    </Grid>
                    <Grid item xs={12} md={12} sm={12}>
                        <div>
                            <CkEditorText
                                placeholder='If yes, please enter details, if no please enter.. "N/A"'
                                disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'fleet'}
                                htmlData={data?.powerplant_fleet_tech_summaries?.fleet_composition?.time_note || ''}
                                onChangeData={(value) => setData({
                                    ...data,
                                    powerplant_fleet_tech_summaries: {
                                        ...data?.powerplant_fleet_tech_summaries,
                                        fleet_composition: {
                                            ...data?.powerplant_fleet_tech_summaries?.fleet_composition,
                                            time_note: value
                                        }
                                    }
                                })}
                            />
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <span>If yes, Sales and Marketing</span>
                        <Autocomplete
                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'fleet'}
                            options={['has', 'has not']}
                            getOptionLabel={option => option}
                            style={{ display: 'inline-grid', marginLeft: '5px', width: "125px" }}
                            id="marketing"
                            value={['has', 'has not'].filter(item => item === data?.powerplant_fleet_tech_summaries?.fleet_composition?.marketing)[0] || null}
                            onChange={(e, value) => onFieldChange(e, 'marketing', value, 'powerplant_fleet_tech_summaries', '', '', 'fleet_composition')}
                            renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin="normal" fullWidth />}
                        />
                        <span className='span-style'>been made aware of this requirement.</span>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            variant='outlined'
                            disabled
                            value={data?.lessee_id || ''}
                            InputLabelProps={{ shrink: true }}
                            placeholder="Enter"
                            size='small'
                        />
                        <span className='span-style'>route network</span>
                        <Autocomplete
                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'fleet'}
                            options={['was', 'was not']}
                            getOptionLabel={option => option}
                            className='engine-stand-select'
                            style={{ display: 'inline-grid', marginLeft: '5px', width: "125px" }}
                            id="route_network"
                            value={['was', 'was not'].filter(item => item === data?.powerplant_fleet_tech_summaries?.fleet_composition?.route_network)[0] || null}
                            onChange={(e, value) => onFieldChange(e, 'route_network', value, 'powerplant_fleet_tech_summaries', '', '', 'fleet_composition')}
                            renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin="normal" fullWidth />}
                        />
                        <span className='span-style'>discussed.</span>
                    </Grid>
                    <Grid item xs={12} md={12} sm={12}>
                        <div>
                            <CkEditorText
                                placeholder='If yes, please enter details, if no please enter.. "N/A"'
                                disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'fleet'}
                                htmlData={data?.powerplant_fleet_tech_summaries?.fleet_composition?.route_network_note || ''}
                                onChangeData={(value) => setData({
                                    ...data,
                                    powerplant_fleet_tech_summaries: {
                                        ...data?.powerplant_fleet_tech_summaries,
                                        fleet_composition: {
                                            ...data?.powerplant_fleet_tech_summaries?.fleet_composition,
                                            route_network_note: value
                                        }
                                    }
                                })}
                            />
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            variant='outlined'
                            disabled
                            value={data?.lessee_id || ''}
                            InputLabelProps={{ shrink: true }}
                            placeholder="Enter"
                            size='small'
                        />
                        <span className='span-style'>expansion plan</span>
                        <Autocomplete
                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'fleet'}
                            options={['was', 'was not']}
                            getOptionLabel={option => option}
                            className='engine-stand-select'
                            style={{ display: 'inline-grid', marginLeft: '5px', width: "125px" }}
                            id="expansion_plan"
                            value={['was', 'was not'].filter(item => item === data?.powerplant_fleet_tech_summaries?.fleet_composition?.expansion_plan)[0] || null}
                            onChange={(e, value) => onFieldChange(e, 'expansion_plan', value, 'powerplant_fleet_tech_summaries', '', '', 'fleet_composition')}
                            renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin="normal" fullWidth />}
                        />
                        <span className='span-style'>discussed.</span>
                    </Grid>
                    <Grid item xs={12} md={12} sm={12}>
                        <div>
                            <CkEditorText
                                placeholder='If yes, please enter details, if no please enter.. "N/A"'
                                disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'fleet'}
                                htmlData={data?.powerplant_fleet_tech_summaries?.fleet_composition?.expansion_plan_note || ''}
                                onChangeData={(value) => setData({
                                    ...data,
                                    powerplant_fleet_tech_summaries: {
                                        ...data?.powerplant_fleet_tech_summaries,
                                        fleet_composition: {
                                            ...data?.powerplant_fleet_tech_summaries?.fleet_composition,
                                            expansion_plan_note: value
                                        }
                                    }
                                })}
                            />
                        </div>
                    </Grid>
                    <p style={{ margin: '20px 0px 10px' }}>General comments on Customer Fleet : </p>
                    <Grid item xs={12} md={12} sm={12}>
                        <div>
                            <CkEditorText
                                placeholder='If yes, please enter details, if no please enter.. "N/A"'
                                disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'fleet'}
                                htmlData={data?.powerplant_fleet_tech_summaries?.fleet_general_comment || ''}
                                onChangeData={(value) => setData({
                                    ...data,
                                    powerplant_fleet_tech_summaries: {
                                        ...data.powerplant_fleet_tech_summaries,
                                        fleet_general_comment: value
                                    }
                                })}
                            />
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            variant='outlined'
                            disabled
                            value={data?.lessee_id || ''}
                            InputLabelProps={{ shrink: true }}
                            placeholder="Enter"
                            size='small'
                        />
                        <Autocomplete
                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'fleet'}
                            options={['has', 'has not']}
                            getOptionLabel={option => option}
                            className='engine-stand-select'
                            style={{ display: 'inline-grid', marginLeft: '5px', width: "125px" }}
                            id="shared"
                            value={['has', 'has not'].filter(item => item === data?.powerplant_fleet_tech_summaries?.fleet_composition?.shared)[0] || null}
                            onChange={(e, value) => onFieldChange(e, 'shared', value, 'powerplant_fleet_tech_summaries', '', '', 'fleet_composition')}
                            renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin="normal" fullWidth />}
                        />
                        <span className='span-style'>shared a copy of their Air Operator Certificate.</span>
                    </Grid>
                </Grid>
            </Paper>
            {deleteModal?.modal ?
                <DeletePopUp
                    modal={deleteModal.modal}
                    toggleModalFn={() => setDeleteModal({ modal: false, data: null })}
                    title="Fleet Composition"
                    content={<h4>Are you sure you want to delete?</h4>}
                    deleteRecordFn={() => fleetCompfn('', deleteModal?.data)}
                /> : null
            }
        </section>
    );
}

export default FleetComposition